<template>
  <div class="portfolio_edit_textarea mt10">
      <quill-editor
          ref="contentEditor"
          class="h300"
          v-model="portfolio"
          :options="editorOption"
      />
  </div>
</template>

<script>
import quillEditorMixins from "@/mixins/quillEditorMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import memberValidator from "@/mixins/validators/memberValidator";

export default {
  name: "MemberWritePortfolioLayout",
  mixins: [quillEditorMixins, memberValidator],
  components: {
  },
  inject: ['memberWriteSetData'],
  provide() {
    return{

    }
  },
  props: {
    memberData: {default: () => {}},
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.initSetData();
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    initSetData() {
      if(util.isEmpty(this.memberData)) {
        return false;
      }
      this.portfolio = this.memberData.mb_portfolio;
      this.portfolio = util.htmlDecode(this.portfolio);
      this.parentChange('portfolio', this.portfolio);
    },
    parentChange(type, value) {
        if(type === 'portfolio'){
            this.content = this.replaceN(value);
            value = this.content
        }
      this.memberWriteSetData(type, value);
    },
  },
  watch: {
    'portfolio': {
      deep: true,
      handler: function (val, oldVal) {
        this.parentChange('portfolio', this.portfolio)
      },
    }
  },
}
</script>

<style scoped>

</style>
